// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanGracePeriodDto
 */
export interface IPlanGracePeriodDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanGracePeriodDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanGracePeriodDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanGracePeriodDto
     */
    start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanGracePeriodDto
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanGracePeriodDto
     */
    account_type?: IPlanGracePeriodDtoAccountTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPlanGracePeriodDto
     */
    claim_last_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanGracePeriodDto
     */
    coverage_end_date?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPlanGracePeriodDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IPlanGracePeriodDto interface.
 */
export function instanceOfIPlanGracePeriodDto(value: object): value is IPlanGracePeriodDto {
    return true;
}

export function IPlanGracePeriodDtoFromJSON(json: any): IPlanGracePeriodDto {
    return IPlanGracePeriodDtoFromJSONTyped(json, false);
}

export function IPlanGracePeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanGracePeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'start_date': json['start_date'] == null ? undefined : json['start_date'],
        'end_date': json['end_date'] == null ? undefined : json['end_date'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'claim_last_date': json['claim_last_date'] == null ? undefined : (new Date(json['claim_last_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
    };
}

export function IPlanGracePeriodDtoToJSON(json: any): IPlanGracePeriodDto {
    return IPlanGracePeriodDtoToJSONTyped(json, false);
}

export function IPlanGracePeriodDtoToJSONTyped(value?: IPlanGracePeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'start_date': value['start_date'],
        'end_date': value['end_date'],
        'account_type': value['account_type'],
        'claim_last_date': value['claim_last_date'] == null ? undefined : ((value['claim_last_date']).toISOString().substring(0,10)),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString().substring(0,10)),
    };
}

